import { HuitabModal } from '../../../../shared/components/common/huitab-modal';
import { PageManager } from '../../../../shared/services/page-manager';
import { PageTypes } from '../../../../shared/services/settings-loader';

export class ModalConfirmationImportInterlocuteurs extends HuitabModal {
  /**
   * Initialise une nouvelle instance de type {@type ModalConfirmationImportInterlocuteurs}.
   */
  constructor() {
    super('modal-confirmation-import-interlocuteurs');

    this.onDismiss(() => {
      PageManager.redirectTo(PageTypes.INTERLOCUTEURS_COUPURES);
    });
  }
}
